<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <circle cx="12" cy="7" r="4" fill="currentColor" />
    <path d="M18 21a1 1 0 0 0 1-1A7 7 0 0 0 5 20a1 1 0 0 0 1 1Z" fill="currentColor"/>
  </svg>
</template>